<template>
  <vue-good-table
    :columns="columns"
    :rows="filteredFaculties"
    :line-numbers="true"
  >
    <template slot="table-row" slot-scope="props">
      <span v-if="props.column.field == 'action'">
        <b-button variant="primary" class="mr-2" size="sm" :to="{ name: 'settings.faculties.show', params: { id: props.row.id } }">
          ดูข้อมูล
        </b-button>
        <b-button variant="danger" size="sm" @click="$emit('delete', props.row)">
          ลบ
        </b-button>
      </span>
    </template>

    <div slot="emptystate" class="text-center text-muted py-2">
      ไม่มีข้อมูล
    </div>
  </vue-good-table>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'

export default {
  components: {
    VueGoodTable
  },
  props: {
    content: { type: Array, default: () => ([]) },
    searchTerm: { type: String, required: false, default: null }
  },
  data () {
    return {
      columns: [
        {
          label: 'ชื่อคณะ',
          field: 'name'
        },
        {
          label: 'การกระทำ',
          field: 'action',
          width: '150px',
          tdClass: 'text-center'
        }
      ]
    }
  },
  computed: {
    filteredFaculties () {
      if (this.searchTerm !== null) {
        return this.content.filter((group) => group.name.includes(this.searchTerm))
      } else {
        return this.content
      }
    }
  }
}
</script>

<style>

</style>
